/**
 * Debug logger — silent unless debug mode is enabled
 * (config.debug / data-debug="true"). Publishers don't want our logs in their console.
 * The flag lives on globalThis so the lazily loaded extras script shares it.
 */

const g = globalThis as any;

export function setDebug(enabled: boolean): void {
  g.__readingvoxDebug = enabled;
}

export function isDebug(): boolean {
  return !!g.__readingvoxDebug;
}

export function debugLog(...args: any[]): void {
  if (g.__readingvoxDebug) console.log('[ReadingVox]', ...args);
}
